import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Globe, Store, Calendar, User } from "lucide-react";

export default function Navbar() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const styles = {
    nav: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#12873B ",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "0.8rem 0.5rem 1.8rem 0.5rem", // Extra bottom padding for modern mobile screens
      borderTop: "1px solid #12873B ",
      zIndex: 1000,
    },
    navItem: (active) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "4px",
      textDecoration: "none",
      color: active ? "#badbbaff" : "#244d21ff",
      transition: "color 0.2s ease",
    }),
    label: {
      fontSize: "0.65rem",
      fontWeight: "700",
    }
  };

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.navItem(isActive("/"))}>
        <Home size={24} />
        <span style={styles.label}>Home</span>
      </Link>

      <Link to="/calendar" style={styles.navItem(isActive("/calendar"))}>
        <Calendar size={24} />
        <span style={styles.label}>Events</span>
      </Link>

      <Link to="/partners" style={styles.navItem(isActive("/partners"))}>
        <Store size={24} />
        <span style={styles.label}>Partners</span>
      </Link>

      <Link to="/sdgs" style={styles.navItem(isActive("/sdgs"))}>
        <Globe size={24} />
        <span style={styles.label}>SDGs</span>
      </Link>

      <Link to="/profile" style={styles.navItem(isActive("/profile"))}>
        <User size={24} />
        <span style={styles.label}>Profile</span>
      </Link>
    </nav>
  );
}